import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class Globals {
  config: any = {
    platformAdminApi_client_resourceUri: "",
    platformAdminApi_client_resourceScope: "",
    graphApi_client_resourceUri: "",
    graphApi_client_resourceScope: "",
    modelListULR: '',
    deleteModelURL: '',
    assetUrl: '',
    registerModelURL: '',
    platformHubUrl: '',
    platformHomeUrl: ''
  };

  userName = '';
  name: string = '';
  userShortName: string;
  userEmail: string;
  rbacName: string;
  groups: any = [];

  subscription = '';
  releaseDetails: any;
}
